<template>
  <infinity-text-field
    :rules="rules"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>
<script>
  import InfinityTextField from './InfinityTextField.vue'
  export default {
    name: 'InfinityNameField',
    components: { InfinityTextField },
    data: () => {
      return {
        rules: [
          value => !!value || 'Required.',
          value => {
            const re = /[a-z]/
            return re.test((value || ' ')[0]) || 'Starts with an alphabetic character'
          },
          value => (value || '').length >= 3 || 'Min 3 characters',
          value => (value || '').length <= 63 || 'Max 63 characters',
          value => {
            const re = /[a-z0-9]/
            return re.test((value || ' ')[(value || ' ').length - 1]) || 'Ends with an alphanumeric character'
          },
          value => {
            const re = /^(?!-)[a-z][a-z0-9-]{1,63}$/g
            return re.test(value || '') || 'Contain only lowercase alphanumeric characters or "-"'
          },
        ],
      }
    },
  }
</script>
